import { DualRing } from "react-awesome-spinners";
import { LoadingWrapper } from "styles/styledComponents/loadingWrapper";

const Loading = () => {
  return (
    <LoadingWrapper>
      <DualRing />
    </LoadingWrapper>
  );
};

export default Loading;
